<!--  -->
<template>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" class="choiceSpecialModule" title="专题版块" :visible.sync="dialogVisible" width="400px">
        <div class="content">
            <div class="item" @click="changeChoice(index)" :class="{'select': index === selectIndex}" v-for="(item, index) in moduleList" :key="index">
                {{item.topicname}}
                <img :src="require('@/common/images/cms/choice.png')" v-if="index === selectIndex" alt="">
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmModule">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {getAllTopicinfo} from 'api/imageText'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            dialogVisible: false,
            moduleList: [],
            selectIndex: 0
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        open() {
            if (!this.moduleList.length) {
                this.getAllTopicinfo()
            } else {
                this.dialogVisible = true
            }
        },
        changeChoice(index) {
            if (index !== this.selectIndex) {
                this.selectIndex = index
            }
        },
        getAllTopicinfo() {
            this.setLoading(true)
            getAllTopicinfo({
                data: {},
                success: res => {
                    this.setLoading(false)
                    this.dialogVisible = true
                    this.moduleList = res.data.content
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        confirmModule() {
            sessionStorage.moduleObj = JSON.stringify(this.moduleList[this.selectIndex])
            this.$router.push({
                name: 'SpecialConfig',
                query: {
                    topicname: this.moduleList[this.selectIndex].topicname,
                    topiccode: this.moduleList[this.selectIndex].topiccode
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .choiceSpecialModule {
        .content {
            .item {
                width: 320px;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                border: 1px solid #E5E5E5;
                padding-left: 15px;
                font-size: 14px;
                color: #666666;
                cursor: pointer;
                position: relative;
                &:not(:last-of-type) {
                    margin-bottom: 15px;
                }
                &.select {
                    color: #409EFF;
                    border-color: #409EFF;
                }
                img {
                    width: 16px;
                    height: 16px;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                }
            }
        }
        .el-dialog__footer {
            padding: 0;
            .el-button--primary {
                margin-left: 20px;
            }
        }
    }
</style>